<h2 mat-dialog-title class="font-weight-bolder add-data-title">Add Data</h2>
<mat-dialog-content>
  <div *ngIf="features.length > 0" class="upload-layer-container" [formGroup]="newLayerForm">
    <mat-label class="p-2">{{ features.length }} feature results. Select the layers you would like to add as a WFS layer</mat-label>
    <div class="upload-layer-content">
      <div *ngFor="let feature of features; let i = index" class="info-row">
        <mat-checkbox id="{{ feature.Name }}" class="checkbox-padding" (change)="changeCheckFeature($event.checked, feature)">
          <span class="layer-name-label">{{ feature.Name }}</span>
        </mat-checkbox>
      </div>
    </div>
    <div *ngIf="anyChecked()" class="d-flex mt-2 g-2">
      <div class="flex-grow-1">
        <mat-form-field class="form-slim">
          <input matInput placeholder="New Layer Name" formControlName="newLayerName" id="newLayerName" type="text" maxlength="18" />
        </mat-form-field>
      </div>
      <div class="flex-grow-1 d-flex align-items-center g-1">
        <span>Opacity:</span>
        <mat-slider class="flex-grow-1" min="0" max="100" step="1" [displayWith]="formatPercentLabel">
          <input matSliderThumb formControlName="newLayerOpacity">
        </mat-slider>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="elevated" [mat-dialog-close]="false">Back</button>
  <button matButton="filled" color="primary"  id="btnAdd" [mat-dialog-close]="true" [disabled]="!anyChecked()" (click)="addWFSLayers()">
    Add
  </button>
</mat-dialog-actions>
